// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2CEsA","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__T57dT"};